import { pstyle } from "../lib/pstyle.js";

export default function Search({ v }) {
  if (!v.searchOpen) return null;
  return (
    // Backdrop: click-to-dismiss is a mouse-only bonus, not the only way to
    // close (Escape and the "esc" button both work) — giving the whole
    // viewport button/keyboard semantics here would be wrong, not more
    // accessible.
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div onClick={v.closeSearch} className="nd-search-overlay" style={pstyle("position:fixed; inset:0; z-index:40; background:oklch(0.22 0.012 60 / 0.28); display:flex; justify-content:center; padding-top:96px;")}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions -- stopPropagation only, not a user action */}
      <div
        onClick={v.stop}
        className="nd-search-panel"
        role="dialog"
        aria-modal="true"
        aria-label="Recherche"
        style={pstyle("width:760px; max-height:600px; background:oklch(1 0 0); border:1px solid oklch(0.88 0.01 85); border-radius:12px; box-shadow:0 24px 60px oklch(0.2 0.01 60 / 0.18); overflow:hidden; display:flex; flex-direction:column;")}
      >
        <div style={pstyle("display:flex; align-items:center; gap:12px; padding:16px 20px; border-bottom:1px solid oklch(0.94 0.006 85);")}>
          <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:12px; color:oklch(0.56 0.015 60);")}>&gt;</span>
          <input
            ref={v.inputRef}
            value={v.query}
            onChange={v.onQuery}
            onKeyDown={v.onKeyDown}
            placeholder="Rechercher une fiche, une commande, un cours…"
            aria-label="Rechercher"
            style={pstyle("flex:1; border:none; outline:none; font-family:'IBM Plex Sans', Helvetica, sans-serif; font-size:17px; color:oklch(0.22 0.012 60); background:transparent;")}
          />
          <button
            type="button"
            onClick={v.closeSearch}
            aria-label="Fermer la recherche"
            style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:11px; color:oklch(0.56 0.015 60); border:1px solid oklch(0.92 0.008 85); border-radius:4px; padding:2px 6px; cursor:pointer; background:transparent;")}
          >esc</button>
        </div>

        <div className="nd-search-body" style={pstyle("display:grid; grid-template-columns:1fr 300px; flex:1; min-height:0;")}>
          <div style={pstyle("padding:14px 10px; display:flex; flex-direction:column; gap:14px; overflow:auto;")}>
            {v.resultGroups.map((g, gi) => (
              <div key={gi} style={pstyle("display:flex; flex-direction:column; gap:2px;")}>
                <div style={pstyle("font-size:11px; font-weight:600; letter-spacing:0.08em; text-transform:uppercase; color:oklch(0.56 0.015 60); padding:0 12px 6px;")}>{g.name}</div>
                {g.items.map((it, ii) => (
                  // Keyboard operability for this list comes from the text
                  // input above (ArrowUp/Down move `hoverId`, Enter opens
                  // it — see onKeyDown in searchView.js), a roving-focus
                  // listbox pattern — not from making each row individually
                  // tabbable, which would add a redundant second way to
                  // reach the same target.
                  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                  <div
                    key={ii}
                    onClick={it.onClick}
                    onMouseEnter={it.onHover}
                    style={pstyle("display:flex; align-items:center; gap:12px; padding:9px 12px; border-radius:6px; font-size:14px; cursor:pointer;", { background: it.bg })}
                  >
                    <span style={pstyle("width:6px; height:6px; border-radius:50%; flex:none;", { background: it.dot })}></span>
                    <span>{it.title}</span>
                    <span style={pstyle("margin-left:auto; font-size:12px;", { color: it.metaColor })}>{it.meta}</span>
                  </div>
                ))}
              </div>
            ))}
            {v.noResults && (
              <div style={pstyle("padding:24px 12px; font-size:14px; color:oklch(0.55 0.015 60);")}>Aucun résultat. Essayez « bgp », « vlan », « ansible ».</div>
            )}
          </div>

          <div className="nd-search-preview" style={pstyle("border-left:1px solid oklch(0.95 0.006 85); padding:18px 20px; display:flex; flex-direction:column; gap:12px; background:oklch(0.99 0.004 85);")}>
            <div style={pstyle("font-size:11px; font-weight:600; letter-spacing:0.08em; text-transform:uppercase; color:oklch(0.56 0.015 60);")}>Aperçu</div>
            <div style={pstyle("font-size:15px; font-weight:500;")}>{v.preview.title}</div>
            <div style={pstyle("font-size:13px; line-height:1.6; color:oklch(0.45 0.015 60); text-wrap:pretty;")}>{v.preview.summary}</div>
            <pre style={pstyle("margin:0; padding:12px; background:oklch(0.97 0.006 85); border-radius:6px; font-family:'IBM Plex Mono', monospace; font-size:11.5px; line-height:1.7; color:oklch(0.3 0.012 60); white-space:pre-wrap;")}>{v.preview.snippet}</pre>
            <div style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:11px; color:oklch(0.53 0.015 60);")}>{v.preview.path}</div>
          </div>
        </div>

        <div style={pstyle("display:flex; align-items:center; gap:18px; padding:10px 20px; border-top:1px solid oklch(0.94 0.006 85); font-family:'IBM Plex Mono', monospace; font-size:11px; color:oklch(0.53 0.015 60);")}>
          <span>↑↓ naviguer</span><span>↵ ouvrir</span><span>esc fermer</span>
          <span style={pstyle("margin-left:auto;")}>{v.resultCount}</span>
        </div>
      </div>
    </div>
  );
}
